import React from 'react';
import { CtaBlock } from './ui/CtaBlock';
import { OFFER_ANCHOR, PACK_IMAGE, PACK_IMAGE_ALT, PRODUCT_NAME } from '../data/content';
export function Hero() {
  return <header className="border-b border-arena bg-crudo" data-id="element-85" data-mp="ei1vfm5pk2xy">
      <div className="mx-auto max-w-3xl px-4 pb-6 pt-4 text-center sm:pt-7" data-id="element-86" data-mp="9llb731mq8q5">
        <p className="text-xs font-bold uppercase tracking-wide text-olive sm:text-sm" data-id="element-87" data-mp="4mi47d239sfj">
          🧶 MÉTODO DE APRENDIZAJE PASO A PASO
        </p>
        <h1 className="mt-1.5 font-serif text-[1.9rem] leading-[1.08] text-marron sm:text-5xl" data-id="element-88" data-mp="127eereur1rdz">
          El sistema completo para aprender{' '}
          <span className="bg-arena px-1 text-terracota" data-id="element-89" data-mp="sarsclmrys9u">macramé desde cero</span>
        </h1>
        <p className="mx-auto mt-2 max-w-2xl text-sm leading-snug text-marron/80 sm:text-base" data-id="element-90" data-mp="ncq2nhuufupe">
          Aprende a crear tus propias piezas, domina los nudos esenciales y
          transforma tus ideas en proyectos reales — sin perderte entre cientos
          de videos y tutoriales.
        </p>

        <p className="mt-3 rounded-lg bg-terracota px-3 py-2 text-[0.72rem] font-extrabold uppercase leading-tight text-crudo sm:text-sm" data-id="element-91" data-mp="3j7zgtn69y0is">
          🧶 {PRODUCT_NAME} · 6 Tomos + 5 Bonos
        </p>

        <a href={OFFER_ANCHOR} aria-label="Ir a la sección de compra" className="mt-2.5 block overflow-hidden rounded-2xl border-[3px] border-terracota transition-transform duration-150 ease-soft active:scale-[0.99]" data-id="element-92" data-mp="39ausbgoyhsyt">
          <img src={PACK_IMAGE} alt={PACK_IMAGE_ALT} className="block w-full" data-id="element-93" data-mp="30fy9rxjcj3ya" />
        </a>

        <CtaBlock note="Acceso Digital Inmediato • Garantía de 7 Días" data-id="element-94" data-mp="35a2hij0frg0f" />
      </div>
    </header>;
}